import { jwtDecode } from 'jwt-decode';
import type { JwtPayload } from '../types';

const API_TOKEN_RESOLVE_TIMEOUT = 5000;

export function getStoredToken(): string | null {
  return localStorage.getItem('token');
}

export function setStoredToken(token: string): void {
  localStorage.setItem('token', token);
}

export function removeStoredToken(): void {
  localStorage.removeItem('token');
}

export function getStoredAgentKey(): string | null {
  return localStorage.getItem('agent_key');
}

export function setStoredAgentKey(key: string): void {
  localStorage.setItem('agent_key', key);
}

export function removeStoredAgentKey(): void {
  localStorage.removeItem('agent_key');
}

export function decodeToken(token: string): JwtPayload {
  return jwtDecode<JwtPayload>(token);
}

export function isAdmin(): boolean {
  const token = getStoredToken();
  if (!token) return false;
  try {
    return decodeToken(token).admin;
  } catch {
    return false;
  }
}

export function resolveToken(token: string): Promise<Response> {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), API_TOKEN_RESOLVE_TIMEOUT);

  return fetch('/api/token/is_valid', {
    method: 'post',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token }),
    signal: controller.signal,
  }).finally(() => clearTimeout(timeoutId));
}
